import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Table, Spinner } from "react-bootstrap";
import { useGetEmandiReportFiltersQuery } from "features/E-Mandi/EMandiApiSlice";

const BankerMandiComponent = ({ selectedState, selectedDistrict, crops, applicationTabValue }) => {
  const today = new Date();

  const startDate = useMemo(() => {
    const date = new Date(today);
    date.setMonth(today.getMonth() - 1);
    return date;
  }, [today]);

  const endDate = useMemo(() => {
    const date = new Date(today);
    date.setDate(today.getDate() - 1);
    return date;
  }, [today]);

  const formatDate = useCallback((date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }, []);

  const start_date = formatDate(startDate);
  const end_date = formatDate(endDate);

  // Check if the required parameters are valid before querying
  const canFetch = selectedState && selectedDistrict ;

  const { data, isLoading, refetch } = useGetEmandiReportFiltersQuery(
    {
      selectedState,
      selectedDistrict,
      crops,
      start_date,
      end_date,
    },
    {
      skip: !canFetch, // Skip the API call if the condition is not met
    }
  );

  // Effect to refetch on certain changes with debouncing to prevent unnecessary calls
  useEffect(() => {
    if (canFetch) {
      const debounceRefetch = setTimeout(() => {
        if (applicationTabValue) {
          refetch();
        }
      }, 300); // Delay refetch to avoid multiple calls in rapid succession

      return () => clearTimeout(debounceRefetch); // Cleanup timeout
    }
  }, [applicationTabValue, selectedState, selectedDistrict, canFetch, refetch]);

  return (
    <>
      {data?.data?.results?.length > 0 && (
        <>
          <h5 className="p-3 rounded-top bg-secondary2">Mandi Details</h5>

          <div className="table-responsive custom-scrollable-table">
            <Table hover className="table align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Market</th>
                  <th>Variety</th>
                  <th>Arrival Date</th>
                  <th>Min Price</th>
                  <th>Max Price</th>
                  <th>Modal Price</th>
                </tr>
              </thead>
              {isLoading ? (
                <div className="text-center">
                  <Spinner size="sm" />
                </div>
              ) : (
                <tbody>
                  {data?.data?.results?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.market}</td>
                      <td>{item.variety}</td>
                      <td>{item.arrival_date}</td>
                      <td>{item.min_price}</td>
                      <td>{item.max_price}</td>
                      <td>{item.modal_price}</td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </div>
        </>
      )}
    </>
  );
};

export default BankerMandiComponent;
